module.exports = __webpack_public_path__ + "assets/images/iconConversation.0cdfb3a0de818482335b35d822fe1e3d.svg";